<script>
  import { createEventDispatcher } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Button, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  export let active = false;
  export let tooltipActive;
  export let tooltipInactive;
  export let id;

  const dispatch = createEventDispatcher();

  $: label = $format(active ? tooltipActive : tooltipInactive);
</script>

<Button {id} color="link" class="p-0" aria-label={label} on:click={() => dispatch('toggle')}>
  <Icon name={active ? 'lock' : 'lock-open'} color={active ? 'danger' : undefined} />
</Button>
<Tooltip target={id} placement="top">
  {label}
</Tooltip>
